import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UILink from 'UIComponents/link/UILink';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AiAssistantDisclaimer() {
  return /*#__PURE__*/_jsx(Small, {
    use: "help",
    children: /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "m-left-2",
      title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "automation-ui-enrollment.aiAssistantDisclaimer.description_jsx",
        elements: {
          TermsLink,
          PrivacyLink
        }
      }),
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "automation-ui-enrollment.aiAssistantDisclaimer.title_jsx",
        elements: {
          TermsLink
        }
      })
    })
  });
}
function TermsLink({
  children
}) {
  return /*#__PURE__*/_jsx(UILink, {
    href: "https://legal.hubspot.com/hubspot-beta-terms",
    external: true,
    children: children
  });
}
function PrivacyLink({
  children
}) {
  return /*#__PURE__*/_jsx(UILink, {
    href: "https://legal.hubspot.com/privacy-policy",
    external: true,
    children: children
  });
}